import React, { Component } from "react"
import { SelectWithSearch, HttpError } from "../../components"
import * as ApiHelper from "../../ApiHelper"
import Util from "../../Util"
import { LoadModal } from "../modais"
export default class RelatorioGestorForm extends Component {
  constructor() {
    super()
    this.getGestores = this.getGestores.bind(this)
    this.onChangeGestor = this.onChangeGestor.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      gestores: [],
      showLoad: false,
      gestor: "",
      formError: ""
    }
  }
  componentWillMount() {
    this.getGestores()
  }
  onChangeGestor(event) {
    this.setState({
      gestor: event,
      formError: ""
    })
  }
  sendForm(event) {
    event.preventDefault()
    var params = {
      tipo_relatorio: "Gestores",
      gestor_id:
        this.state.gestor === undefined || this.state.gestor === null
          ? null
          : this.state.gestor.value
    }
    this.toggleLoadModal()
    ApiHelper.getRelatorioWith(params, relatorio => {
      this.toggleLoadModal()
      if (relatorio) {
        var url = URL.createObjectURL(relatorio)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute("download", "Relatório de gestores.pdf")
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        console.log("Error")
      }
    })
  }
  getGestores() {
    ApiHelper.getGestores((gestores, error) => {
      if (gestores) {
        var mapped = Util.mapGestores(gestores)
        mapped.shift()
        this.setState({
          gestores: mapped
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <div className="row" style={{ marginTop: 100 }}>
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      )
    }
    return (
      <div className="card card-content">
        <div className="row">
          <LoadModal
            onClose={this.toggleLoadModal}
            show={this.state.showLoad}
          />
          <SelectWithSearch
            error={this.state.formError}
            sizeClass="col-md-8"
            options={this.state.gestores}
            label="Gestor"
            placeholder="Selecione um gestor ou deixe em branco para selecionar todos"
            onChange={this.onChangeGestor}
            value={this.state.gestor}
          />
        </div>
        <div className="row">
          <button
            onClick={this.sendForm}
            type="submit"
            className="btn btn-primary pull-left"
            data-background-color="as-blue"
          >
            Gerar
          </button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/relatorios/RelatorioGestorForm.js